import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/uniregistry': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M192 480c-39.5 0-76.2-11.8-106.7-32.2h213.5c-30.6 20.4-67.3 32.2-106.8 32.2zM102.9 286.9c0 2.5 0.1 5 0.3 7.4h-103.1c-0.1-2.4-0.1-4.9-0.1-7.4v-12.4h102.9v12.4zM123.4 343.9c8.9 10.6 20.1 19.1 33 24.8h-138.3c-3.8-8-7-16.3-9.6-24.8h114.9zM105.7 309.2c2 7.9 5.2 15.4 9.2 22.3h-109.7c-1.7-7.3-3-14.7-3.9-22.3h104.4zM102.9 239.9v17.3h-102.9v-17.3h102.9zM102.9 66.7v4.9h-102.9v-4.9h102.9zM102.9 32v2.5h-102.9v-2.5h102.9zM102.9 101.3v7.4h-102.9v-7.4h102.9zM102.9 205.3v14.8h-102.9v-14.8h102.9zM102.9 136v9.9h-102.9v-9.9h102.9zM102.9 170.6v12.4h-102.9v-12.4h102.9zM269.1 331.5c4-6.9 7.1-14.4 9.2-22.3h104.4c-0.8 7.6-2.1 15-3.9 22.3h-109.7zM281.1 145.8v-9.8h102.9v9.8h-102.9zM281.1 183v-12.4h102.9v12.4h-102.9zM281.1 108.7v-7.4h102.9v7.4h-102.9zM281.1 32h102.9v2.5h-102.9v-2.5zM78.1 442.9c-11.8-8.7-23.6-18.7-33.2-29.7h293.1c-9.5 11.1-20.4 21-32.2 29.7h-227.7zM281.1 71.6v-4.9h102.9v4.9h-102.9zM281.1 220.1v-14.8h102.9v14.8h-102.9zM38.8 405.7c-6.6-8.5-10.6-17.6-15.8-27.2h338.9c-5.2 9.6-11.1 18.7-17.8 27.2h-305.3zM227.6 368.6c12.8-5.6 24.1-14.1 32.9-24.8h115c-2.7 8.6-4.8 16.8-8.5 24.8h-139.4zM281.1 286.9v-12.4h102.9v12.4c0 2.5-0.1 4.9-0.2 7.4h-103.1c0.3-2.4 0.4-4.9 0.4-7.4zM281.1 257.2v-17.3h102.9v17.3h-102.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/uniregistry.js
// module id = 1066
// module chunks = 0